import { DEFAULT_LANGUAGE } from "data/constants"
import { ZendeskAPI } from "views/ZendeskConfig"

const openZendeskChat = (language = DEFAULT_LANGUAGE) => {
  ZendeskAPI("messenger:set", "locale", language)
  ZendeskAPI("messenger", "open")
  ZendeskAPI("messenger", "show")
  ZendeskAPI("messenger:on", "close", () => ZendeskAPI("messenger", "hide"))
}

export default openZendeskChat
